import { ItemRowCell } from '@ukpostbox/frontend-framework';
import { StackedThumbnails } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/StackedThumbnails';
import React from 'react';
import { MapMailItemThumbnails } from './MapMailItemThumbnails';
import { MailItemThumbnailsType, MailPartTypeEnum } from './Types/ThumbnailTypes';

function MailItemThumbnailsStacked(props: MailItemThumbnailsType) {
	return (
		<ItemRowCell extraClass='mail-item-thumbs'>
			<StackedThumbnails>
				<MapMailItemThumbnails
					mailType={MailPartTypeEnum['Mail-Envelopes']}
					files={props.files}
					onClickCallback={props.onClickCallback}
					size={props.size}
				/>
				<MapMailItemThumbnails
					mailType={MailPartTypeEnum['Mail-Contents']}
					files={props.files}
					onClickCallback={props.onClickCallback}
					size={props.size}
					hideMissing
				/>
			</StackedThumbnails>
		</ItemRowCell>
	);
}

export { MailItemThumbnailsStacked };
